export enum CarrierLookupRoutes {
  index = 'user.carrierLookup',
  singleLookup = 'user.carrierLookup.singleLookup',
  bulkLookup = 'user.carrierLookup.bulkLookup',
  history = 'user.carrierLookup.history',
  flow = 'user.carrierLookup.flow',
}

export enum EmailLookupRoutes {
  index = 'user.emailLookup',
  singleLookup = 'user.emailLookup.singleLookup',
  bulkLookup = 'user.emailLookup.bulkLookup',
  history = 'user.emailLookup.history',
  flow = 'user.emailLookup.flow',
}
